module.exports = __webpack_public_path__ + "img/churchplusimage.929c46a6.png";